module.exports = __webpack_public_path__ + "images/evbox67a5b36abcda249762906661e7a7a924.png";